<template>
  <v-container>
    <v-row>
      <v-col cols='12'>
        <wo-processing-lines
          v-if='wo'
          :isLoading='isLoading || isSavingLine'
          :wo='wo'
          :product='product'
          :labour='labour'
          :productLines='productLines'
          :labourLines='labourLines'
          @saveProductLine='saveProductLine'
          @saveLabourLine='saveLabourLine'
          @deleteProductLine='deleteProductLine'
          @deleteLabourLine='deleteLabourLine'
          woOverviewPage
        ></wo-processing-lines>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import wosAPI from '@/modules/wos/api/index'
import servicesAPI from '@/modules/assets/api/services'
import assetsAPI from '@/modules/assets/api/inventory'
import miscServices from '@/services/misc'
import WOProcessingLines from '@/modules/wos/components/WOProcessingLines'

export default {
  name: 'wo-product-labour',
  props: {
    wo: {
      required: true
    }
  },
  data: () => ({
    isLoading: true,
    isSavingLine: false,
    product: [],
    labour: [],
    productLines: [],
    labourLines: [],
  }),
  mounted () {
    this.getData()
  },
  computed: {

  },
  methods: {
    async getData () {
      this.isLoading = true
      let tmp = []
      if (this.wo.project) {
        this.product = await assetsAPI.getInventoryForDivision(this.wo.project_obj.division)
        tmp = await servicesAPI.getServicesForDivision(this.wo.project_obj.division)
      } else if (this.wo.estimate) {
        this.product = await assetsAPI.getInventoryForDivision(this.wo.estimate_obj.division)
        tmp = await servicesAPI.getServicesForDivision(this.wo.estimate_obj.division)
      }
      this.labour = tmp.filter(i => i.is_labour === true)
      this.productLines = await wosAPI.getProductForWO(this.wo.id)
      this.labourLines = await wosAPI.getLabourForWO(this.wo.id)
      this.isLoading = false
    },
    async saveProductLine (line) {
      this.isSavingLine = true
      if (line.id) {
        const tmp = await wosAPI.updateProductForWO(line)
        this.productLines = miscServices.replaceObject(this.productLines, tmp)
      } else {
        line.work_order = this.wo.id
        const tmp = await wosAPI.createProductForWO(line)
        this.productLines.push(tmp)
      }
      this.isSavingLine = false
    },
    async saveLabourLine (line) {
      this.isSavingLine = true
      if (line.id) {
        const tmp = await wosAPI.updateLabourForWO(line)
        this.labourLines = miscServices.replaceObject(this.labourLines, tmp)
      } else {
        line.work_order = this.wo.id
        const tmp = await wosAPI.createLabourForWO(line)
        this.labourLines.push(tmp)
      }
      this.isSavingLine = false
    },
    async deleteProductLine (line) {
      this.isSavingLine = true
      this.lines = await wosAPI.deleteProductForWO(line)
      this.productLines = miscServices.removeObject(this.productLines, line)
      this.isSavingLine = false
    },
    async deleteLabourLine (line) {
      this.isSavingLine = true
      this.lines = await wosAPI.deleteLabourForWO(line.id)
      this.labourLines = miscServices.removeObject(this.labourLines, line)
      this.isSavingLine = false
    }
  },
  components: {
    'wo-processing-lines': WOProcessingLines
  }
}
</script>